/**
 * Recharts palette and brush styling for Sample / Test analytics.
 * Anchored to dashboard brand purple (#535593) and section borders (#e8e8e8).
 */

const dashboardChartTheme = {
  gridStroke: "#e8e8e8",
  /**
   * Extra bottom space so angled X-axis labels sit above the brush (Recharts stacks both in the margin).
   */
  layout: {
    barWithBrush: {
      /** Taller plot; side margins modest — brush labels rely on `.recharts-surface { overflow: visible }` */
      responsiveHeight: 500,
      marginTop: 16,
      marginRight: 48,
      marginLeft: 28,
      marginBottom: 20,
      xAxisHeight: 150,
      xAxisTickMargin: 10,
    },
    lineWithBrush: {
      responsiveHeight: 500,
      marginTop: 16,
      marginRight: 40,
      marginLeft: 24,
      marginBottom: 20,
      xAxisHeight: 132,
      xAxisTickMargin: 8,
    },
    /**
     * Added to left/right chart margins on Test Metrics only. Recharts draws brush labels past
     * the handles (~5px) so without extra inset they overlap the card border.
     */
    testMetricsBrushLabelGutter: 32,
  },
  brush: {
    stroke: "#535593",
    fill: "rgba(83, 85, 147, 0.08)",
    height: 30,
    travellerWidth: 10,
  },
  /** Sample tab: product (primary), environment, total */
  sampleSeries: {
    product: "#535593",
    environment: "#5C9A7A",
    total: "#C9A85C",
  },
  /** Test tab: semantic series tuned to sit with the purple-led theme */
  testMetricsSeries: {
    total: "#C9A85C",
    onTime: "#5AAA6E",
    delayed: "#D65D52",
    pending: "#7079C8",
  },
  line: {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    /** Monotone curves — stable for time series without overshoot */
    curveType: "monotone",
  },
};

export default dashboardChartTheme;
